import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ip-empty-data',
  templateUrl: './ip-empty-data.component.html',
  styleUrls: ['./ip-empty-data.component.scss']
})
export class IpEmptyDataComponent {
  @Input() msgText?: string;
}
